<template>
  <div class="user">
    <div class="photo text-center" :class="'nav-link-'+theme">
     <i class="fa fa-user"></i>
    </div>
    <div class="info" :class="'info-'+theme">
      <a data-toggle="collapse" :aria-expanded="!isClosed" @click.stop="toggleMenu" href="#">
        <span class="text-center">
            <small class="text-grey"> Seja Bem Vindo, </small>
            <span style="font-size: 16px;">
            <strong>
              {{ $auth.user().name }}
            </strong>
              <b class="caret"></b>
            </span>
        </span>
      </a>
      <div class="clearfix"></div>
      <div>
        <el-collapse-transition>
          <ul class="nav" v-show="!isClosed">
            <slot>
              <br>
              <li :class="'nav-link-'+theme">
                <router-link to="/user" class="profile-dropdown" href="/user">
                  <span class="sidebar-mini">
                    <i class="fa fa-address-card"></i>
                  </span>
                  <span class="sidebar-normal">Meu Perfil</span>
                </router-link>
                <router-link to="/signature" class="profile-dropdown" href="/signature">
                  <span class="sidebar-mini">
                    <i class="fas fa-file-signature"></i>
                  </span>
                  <span class="sidebar-normal">Minha Assinatura</span>
                </router-link>
                <router-link to="/notices" class="profile-dropdown" href="/notices">
                  <span class="sidebar-mini">
                    <i class="fa fa-exclamation-circle"></i>
                  </span>
                  <span class="sidebar-normal">Avisos</span>
                </router-link>
                <router-link to="/faq" class="profile-dropdown" href="/faq">
                  <span class="sidebar-mini">
                    <i class="fa fa-edit"></i>
                  </span>
                  <span class="sidebar-normal">FAQ e Dúvidas</span>
                </router-link>
                <a
                  href="#"
                  class="profile-dropdown"
                  @click.prevent="$auth.logout({makeRequest: true, redirect: '/login'})"
                >
                  <span class="sidebar-mini">
                    <i class="fa fa-door-open"></i>
                  </span>
                  <span class="sidebar-normal">Sair</span>
                </a>
              </li>
            </slot>
          </ul>
        </el-collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
import CollapseTransition from "element-ui/lib/transitions/collapse-transition";
import md5 from "js-md5";

export default {
  components: {
    [CollapseTransition.name]: CollapseTransition
  },
  props: {
    title: {
      type: String,
      default: "Tania Andrew"
    }
  },
  data() {
    return {
      isClosed: true,
      gravatar:
        "https://www.gravatar.com/avatar/" + md5(this.$auth.user().email)
    };
  },
  computed: {
    theme() {
      return this.$auth.user().layout;
    }
  },
  methods: {
    toggleMenu() {
      this.isClosed = !this.isClosed;
    }
  }
};
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
.nav-link-black a span i,
.nav-link-black a span,
.info-black a span {
  color: #d8d8d8;
}

.nav-link-light a span i,
.nav-link-light a span,
.info-light a span {
  color: #03141e;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Layout/Extra/UserMenu.vue